export const rollUpLocales = {
    en_AG: ['en_CB', 'en_US'],
    en_AI: ['en_CB', 'en_US'],
    en_AW: ['en_CB', 'en_US'],
    en_BB: ['en_CB', 'en_US'],
    en_BM: ['en_CB', 'en_US'],
    en_BQ: ['en_CB', 'en_US'],
    en_BS: ['en_CB', 'en_US'],
    en_CW: ['en_CB', 'en_US'],
    en_DM: ['en_CB', 'en_US'],
    en_GD: ['en_CB', 'en_US'],
    en_HT: ['en_CB', 'en_US'],
    en_JM: ['en_CB', 'en_US'],
    en_KN: ['en_CB', 'en_US'],
    en_KY: ['en_CB', 'en_US'],
    en_LC: ['en_CB', 'en_US'],
    en_SX: ['en_CB', 'en_US'],
    en_TC: ['en_CB', 'en_US'],
    en_TT: ['en_CB', 'en_US'],
    en_VC: ['en_CB', 'en_US'],
    en_VG: ['en_CB', 'en_US'],

    es_US: ['es'],
    es_AR: ['es'],
    es_BO: ['es'],
    es_CL: ['es'],
    es_CO: ['es'],
    es_CR: ['es'],
    es_DO: ['es'],
    es_EC: ['es'],
    es_SV: ['es'],
    es_GT: ['es'],
    es_HN: ['es'],
    es_MX: ['es'],
    es_NI: ['es'],
    es_PA: ['es'],
    es_PY: ['es'],
    es_PE: ['es'],
    es_PR: ['es'],
    es_UY: ['es'],
    es_VE: ['es'],

    en_CA: ['en_US'],
    en_BZ: ['en_US'],
    en_PR: ['en_US'],

    pt_BR: ['pt'],
    pt_PT: ['pt'],

    en_BE: ['en_EU', 'en_US'],
    en_DK: ['en_EU', 'en_US'],
    en_FI: ['en_EU', 'en_US'],
    en_FR: ['en_EU', 'en_US'],
    en_DE: ['en_EU', 'en_US'],
    en_IE: ['en_EU', 'en_US'],
    en_IL: ['en_EU', 'en_US'],
    en_IT: ['en_EU', 'en_US'],
    en_NL: ['en_EU', 'en_US'],
    en_NO: ['en_EU', 'en_US'],
    en_RU: ['en_EU', 'en_US'],
    en_ES: ['en_EU', 'en_US'],
    en_SE: ['en_EU', 'en_US'],
    en_CH: ['en_EU', 'en_US'],
    en_GB: ['en_EU', 'en_US'],
    en_CZ: ['en_EU', 'en_US'],
    en_HU: ['en_EU', 'en_US'],
    en_IS: ['en_EU', 'en_US'],
    en_PT: ['en_EU', 'en_US'],

    fr_FR: ['fr'],
    fr_BE: ['fr'],
    fr_CH: ['fr'],
    fr_CA: ['fr'],

    it_IT: ['it', 'en_EU', 'en_US'],

    nl_NL: ['nl', 'en_US'],
    nl_BE: ['nl', 'en_US'],

    es_ES: ['es'],

    de_DE: ['de', 'en_EU', 'en_US'],
    de_CH: ['de', 'en_EU', 'en_US'],
    fi_FI: ['fi', 'en_EU', 'en_US'],
    ru_RU: ['ru', 'en_EU', 'en_US'],

    en_AU: ['en_AP', 'en_US'],
    en_CN: ['en_AP', 'en_US'],
    en_HK: ['en_AP', 'en_US'],
    en_IN: ['en_AP', 'en_US'],
    en_JP: ['en_AP', 'en_US'],
    en_KR: ['en_AP', 'en_US'],
    en_NZ: ['en_AP', 'en_US'],
    ja_JP: ['ja', 'en_AP', 'en_US'],
    ko_KR: ['ko', 'en_AP', 'en_US'],
    zh_CN: ['zh', 'en_AP', 'en_US'],
    zh_HK: ['zh', 'en_AP', 'en_US']
};
